import React from "react";
import styles from "./styles.module.css";
import chartSvg from "../../../assest/chart/1.svg";
import chartSvg1 from "../../../assest/chart/1_1.svg";
import { useSelector } from "react-redux";

export default function CardKPI({ key, data }) {

  const { theme } = useSelector((state) => state.theme);
  console.log('Data',data);
  
  return (

   

    <div key={key && key} className="w-full ml-3 ">

<div
        className={` flex-column gap-1  mt-5 ${
          theme === "light"
            ? "bg-secondaryColor text-primaryColor"
            : "bg-darkThirsary text-darkSecondary"
        } `}
      >
      <h1 className="text-xl font-bold  ml-3 ">{data.heading}</h1>  

      
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-5 mt-3 ml-3 mr-2 `}
      >
        {data.contents.length
          ? data.contents.map(({ Icon, label, count }, i) => (
              <div
                key={i}
                className={`${styles.kpiCard} p-4  flex flex-col gap-4  `}
              >
                <div className="flex gap-4 items-center ">
                  <p className={`${styles.pIcon} `}>
                    <Icon className="text-RedColor"/>
                  </p>
                  <p className="font-bold text-lg ">{label}</p>
                </div>

                <div className="flex justify-between items-end">
                  <p className="font-bold text-lg ">{count}</p>
                  <span className="relative">
                    <img src={chartSvg} alt="chart" className="block" />
                    <img
                      src={chartSvg1}
                      alt="chart"
                      className="block absolute top-[11px]"
                    />
                  </span>
                </div>
              </div>
            ))
          : ""}
      </div>
      

    </div>

    </div>
  );
}
